module.exports = __webpack_public_path__ + "resources/travel-9f472dcca0f36a0dd13f7361f3999e0f.svg";